import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MapPin, ShieldCheck, Lock, ArrowRight } from "lucide-react";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [token, setToken] = useState("");

  const handleLogin = (e) => {
    e.preventDefault();

    if (!token.trim()) {
      alert("Please enter admin access token.");
      return;
    }

    localStorage.setItem("admin-auth", token.trim());
    navigate("/admin");
  };

  return (
    <div className="min-h-screen bg-[#F5F9FC] flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-5xl grid lg:grid-cols-2 rounded-[2rem] overflow-hidden shadow-2xl border border-slate-200 bg-white">
        <div className="bg-gradient-to-br from-[#EEF5FB] to-[#DCEEFF] p-10 text-slate-900 relative overflow-hidden">
          <div className="absolute -top-20 -right-20 w-64 h-64 bg-white/70 rounded-full blur-3xl" />
          <div className="absolute -bottom-24 -left-24 w-72 h-72 bg-[#356DFF]/10 rounded-full blur-3xl" />

          <div className="relative z-10">
            <div className="w-16 h-16 rounded-3xl bg-white flex items-center justify-center shadow-lg mb-8 border border-slate-100">
              <MapPin className="w-9 h-9 text-[#356DFF]" />
            </div>

            <h1 className="text-5xl font-black tracking-tight text-slate-900">
              PinMyDoc
            </h1>

            <p className="mt-3 text-slate-600 text-lg">
              Admin Operations Portal
            </p>

            <div className="mt-10 space-y-4">
              <div className="flex items-center gap-3 rounded-2xl bg-white/80 border border-slate-200 p-4">
                <ShieldCheck className="w-6 h-6 text-[#16B364]" />
                <span className="text-sm font-medium text-slate-700">
                  Manage live provider records safely
                </span>
              </div>

              <div className="flex items-center gap-3 rounded-2xl bg-white/80 border border-slate-200 p-4">
                <Lock className="w-6 h-6 text-[#16B364]" />
                <span className="text-sm font-medium text-slate-700">
                  Review launch checklist and platform readiness
                </span>
              </div>
            </div>

            <p className="mt-12 text-sm text-slate-500">
              Your Doctor. Pinned. Right Now.
            </p>
          </div>
        </div>

        <div className="p-8 sm:p-12">
          <div className="mb-8">
            <p className="text-xs font-bold tracking-[0.25em] uppercase text-[#356DFF]">
              Secure Admin Login
            </p>

            <h2 className="mt-3 text-3xl font-black text-slate-900">
              Welcome back
            </h2>

            <p className="mt-2 text-slate-500">
              Enter your admin access token to continue.
            </p>
          </div>

          <form onSubmit={handleLogin} className="space-y-5">
            <div>
              <label className="block text-sm font-bold text-slate-700 mb-2">
                Admin Token
              </label>

              <input
                type="password"
                value={token}
                onChange={(e) => setToken(e.target.value)}
                placeholder="Enter secure token"
                className="w-full rounded-2xl border border-slate-200 bg-white px-5 py-4 text-slate-800 outline-none focus:border-[#356DFF] focus:ring-4 focus:ring-blue-100"
              />
            </div>

            <button
              type="submit"
              className="w-full rounded-2xl bg-gradient-to-r from-[#356DFF] to-[#5B8CFF] text-white py-4 font-bold shadow-lg hover:scale-[1.01] transition-all flex items-center justify-center gap-2"
            >
              Login to Admin
              <ArrowRight className="w-5 h-5" />
            </button>
          </form>

          <div className="mt-8 rounded-2xl bg-[#EEF5FB] border border-[#D7E7F6] p-4 text-sm text-slate-600">
            Access is limited to authorized PinMyDoc administrators only.
          </div>
        </div>
      </div>
    </div>
  );
}